import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Contract} from '../models/contract';
import {contractActionTypes, LoadContractSuccessAction} from '../actions/contract-load';
import {contractAddActionTypes} from '../actions/contract-add';

export interface ContractState {
  contract: Contract;
}

const initialState: ContractState = {
  contract: undefined
};

export function ContractReducer(state: ContractState = initialState, action: Action): ContractState {
  switch (action.type) {
    case contractAddActionTypes.ADD_SUCCESS:
    case contractActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case contractActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case contractActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ContractState, action: LoadContractSuccessAction): ContractState {
  const newState: ContractState = {
    contract: action.payload
  };
  return newState;
}

function handleLoadClearActions(): ContractState {
  return initialState
}

function handleLoadErrorActions(state: ContractState): ContractState {
  return state;
}

export const contractSelectors = {
  contract: (state: ContractState) => _.get(state, 'contract', null)
};


